import React, {useState} from 'react'
import PropTypes from 'prop-types';
import {makeStyles} from "@material-ui/core";
import OrganizationsSelect from "components/OrganizationsSelect";
import Tr from "translations/Translations";
import TextInput from "components/TextInput";
import Box from "@material-ui/core/Box";
import UploadFile from "components/UploadFile";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Typography from "@material-ui/core/Typography";
import CorrespondenceService from "services/CorrespondenceService";
import {connect} from "react-redux";
import scrollTo from "libs/scrollTo";
import contractorNameBuilder from "libs/contractorNameBuilder";
import Dialog from "components/Dialog";
import Loading from "components/Loading";
import CorrespondenceEmailList from "./CorrespondenceEmailList";
import SingleButton from "components/popup/components/SingleButton";
import useSnackbar from "hooks/useSnackbar";
import downloadFile from "../../../libs/downloadFile";

const useStyle = makeStyles(theme => ({
    buttons: {
        marginTop: theme.spacing(2)
    },
    linkToSection: {
        cursor: 'pointer'
    }
}));

function NewMessageForm(
    {
        rfxRoundId,
        contractor,
        formikProps,
        message,
        error,
        working,
        autoSave,
        updateMessage,
        deleteMessage,
        currentActive,
        threadsAfterEndDate
    }) {

    const classes = useStyle();
    const [contractorListForSelect] = useState(contractor ? [] : message.availableRecipients.map(x => ({label: contractorNameBuilder(x), value: x.id})));
    const [contractorEmailList, setContractorEmailList] = useState(null);
    const {enqueueErrorSnackbar} = useSnackbar();

    const doAutoSave = () => {
        autoSave();
    }

    const handleSubmit = (type) => {
        updateMessage(type, formikProps);
    }

    const handleDelete = () => {
        deleteMessage(message.messageId);
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('delete'), handleDelete, 'outlined', working));
        if (!contractor) {
            buttons.push(createButton(Tr('send_and_publish'), () => handleSubmit('publish'), 'outlined', !currentActive || working));
        }
        buttons.push(createButton(Tr('save'), () => handleSubmit('save'), 'outlined', !currentActive || working));
        buttons.push(createButton(Tr('send'), () => handleSubmit('send'), undefined, !currentActive || working));
        return buttons;
    }

    const chipClick = (e) => {
        const rec = message.availableRecipients.find(x => contractorNameBuilder(x) === e.target.innerText);
        if (rec.id.startsWith("EXT_")) {
            setContractorEmailList({recipient: rec, emails: [rec.email]})
        } else {
            setContractorEmailList({})
            CorrespondenceService.getBuyerContractorEmailList(rfxRoundId, rec.contractorDepartmentId).then(setContractorEmailList).catch(() => {
                setContractorEmailList(null)
                enqueueErrorSnackbar(Tr("unknown_error_message"));
            })
        }

    }

    const downloadAttachment = (attachment) => {
        const method = contractor ? CorrespondenceService.downloadContractorMessageAttachment : CorrespondenceService.downloadBuyerMessageAttachment;
        !!attachment.identity ? method(rfxRoundId, attachment.identity) : downloadFile(attachment.file)
    }

    return (
        <>
            {error && <Typography color='error'>{error}</Typography>}

            {!contractor &&
                <OrganizationsSelect
                    id='supplierRecipientIds'
                    formikProps={formikProps}
                    label={Tr('choose_recipients')}
                    required
                    //disabled={working}
                    items={contractorListForSelect}
                    className={classes.uploadFile}
                    onChange={doAutoSave}
                    onChipClick={chipClick}
                    chipTitle={Tr("correspondence_email_title")}
                />
            }

            <TextInput
                id='contents'
                formikProps={formikProps}
                label={Tr('contents')}
                //disabled={working}
                onChange={doAutoSave}
                multiline
                required
            />

            <Box component="div" className={classes.uploadFile}>
                <UploadFile
                    id='attachments'
                    formikProps={formikProps}
                    label={Tr("attachment")}
                    onUploadPopupClosed={doAutoSave}
                    onDelete={doAutoSave}
                    onDownload={downloadAttachment}
                />
            </Box>

            {
                !currentActive && <Typography color="error" className={classes.linkToSection}
                                              onClick={() => scrollTo(`#section_${CorrespondenceService.CORRESPONDENCE_THREAD_LISTS_AFTER_END_DATE_RESOURCE_ID}`)}>
                    {Tr('correspondence_disabled_section', {name: threadsAfterEndDate.name})}</Typography>
            }
            <MultiButton className={classes.buttons} buttons={getButtons()}/>

            {
                !!contractorEmailList &&
                <Dialog
                    open
                    maxWidth="md"
                    title={Tr("correspondence_email_notification_list")}
                    dialogActions={<SingleButton disabled={!contractorEmailList.recipient} label={Tr("close")} onClick={() => setContractorEmailList(null)}/>}
                    onClose={!contractorEmailList.recipient ? undefined : () => setContractorEmailList(null)}
                >
                    {
                        !contractorEmailList.recipient ? <Loading/> : <CorrespondenceEmailList wrapper={contractorEmailList}/>
                    }

                </Dialog>
            }
        </>
    )
}

NewMessageForm.propTypes = {
    classes: PropTypes.any,
}
const mapStateToProps = (state) => {
    return {
        threadsAfterEndDate: state.resources[CorrespondenceService.CORRESPONDENCE_THREAD_LISTS_AFTER_END_DATE_RESOURCE_ID],
    }
};

export default connect(mapStateToProps, {})(NewMessageForm);